import { IRun, IRunStateUpdate } from '../../shared/types/api/playbook.type'

export interface IEvents {
  [key: string]: {
    events: IEvent[]
    eventsDate: Date
  }
}

export interface IEvent {
  created_at: Date
  text: string
  details?: string
  run: IRun
  run_state_updates: Array<IRunStateUpdate>
  playbook: {
    id: number
    slug: string
    custom_state: any
  }
  status: EventStatus
}

export enum EventStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
